import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ChakraProvider } from '@chakra-ui/react';
import theme from '../../theme';
// cmx
import CMx from '../cmx/cmx-component';
import Login from '../login/login-component';
import AmplifyDeprecated from '../../views/amplify-deprecated/amplify-deprecated';
import store, { history } from '../../store/store';
import '../../core/session-management';
import { isNewDesign } from '../../core/middleware/new-design-middleware';
// assets (shared styles loaded via ../../styles in entry)
import '@fontsource/roboto';
import { getConfig } from '../../actions/login.action';
function Template() {
    const [isNewDesign2, setIsNewDesign2] = useState(false);
    useEffect(()=>{
        const fetchConfig = async ()=>{
            const { newDesign } = await getConfig();
            setIsNewDesign2(newDesign?.enabled);
        };
        fetchConfig();
    }, [
        isNewDesign2
    ]);
    const routableApp = /*#__PURE__*/ _jsx(Provider, {
        store: store,
        children: /*#__PURE__*/ _jsx(Router, {
            history: history,
            children: /*#__PURE__*/ _jsxs(Switch, {
                children: [
                    /*#__PURE__*/ _jsx(Route, {
                        path: [
                            '/accelerate',
                            '/accelerate/'
                        ],
                        component: AmplifyDeprecated
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        path: "/cmx",
                        component: CMx
                    }),
                    /*#__PURE__*/ _jsx(Route, {
                        exact: true,
                        path: [
                            '/',
                            '/choose/context/',
                            '/update-password/',
                            '/forgot-password/',
                            '/forgot-password/reset/',
                            '/eula/',
                            '/choose/service-line/',
                            '/sso/:orgCode?'
                        ],
                        component: Login
                    })
                ]
            })
        })
    });
    if (isNewDesign || isNewDesign2) {
        return /*#__PURE__*/ _jsx(ChakraProvider, {
            theme: theme,
            children: routableApp
        });
    }
    return routableApp;
}
export default Template;
